<script lang="ts">
	import { Modal, Container, Text, Button } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';

	export let showModal = false;
	export let duplicateItemModalNotification = '';
	export let name = '';
</script>

<Modal
	on:close={() => {
		showModal = false;
	}}
	{showModal}
	title={$format('modal_duplicate_title', { default: 'Duplicate widgets' })}
>
	<Container slot="content">
		<Text>
			{$format('on_duplicate_item_card_msg', {
				values: { card_name: name },
				default: duplicateItemModalNotification,
			})}
		</Text>
	</Container>

	<div slot="footer" class="d-flex justify-content-end">
		<Button
			variant="secondary"
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			responsiveSize={{
				sm: 'm',
			}}
			on:click={() => {
				showModal = false;
			}}
		>
			{$format('button_cancel', { default: 'Cancel' })}
		</Button>
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			responsiveSize={{
				sm: 'm',
			}}
			on:click
		>
			{$format('button_save', { default: 'Save' })}
		</Button>
	</div>
</Modal>
